<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-toolbar flat color="white">
        <v-toolbar-title>الفواتير النهائية</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="البحث"
          single-line
          hide-details
        ></v-text-field>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="fatworas"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <tr
            :style="[
              props.item.status == '5'
                ? { 'background-color': '#D4B1B1' }
                : { 'background-color': '#fff' }
            ]"
          >
            <td>{{ props.item.code }}</td>
            <td class="text-xs-right">
              {{ props.item.client ? props.item.client.name : "" }}
            </td>
            <td class="text-xs-right">
              {{
                props.item.client && props.item.client.mandob_sales
                  ? props.item.client.mandob_sales.name
                  : ""
              }}
            </td>
            <td class="text-xs-right">{{ props.item.store.name }}</td>
            <td class="text-xs-right">{{ props.item.price_after }}</td>
            <td class="text-xs-right">{{ props.item.created_at }}</td>
            <td class="text-xs-right">{{ props.item.taslim_date }}</td>
            <td>
              <v-icon
                small
                class="ml-4"
                @click="
                  detailItem2(props.item);
                  detail_dialog = true;
                "
              >
                book
              </v-icon>
            </td>
            <td>
              <router-link :to="'/FinalFatworasPrint/' + props.item.id"
                ><v-icon>print</v-icon></router-link
              >
            </td>
            <td>
              <v-btn
                v-if="props.item.status == '5'"
                small
                @click="accept_fatwora(props.item.id)"
                >قبول</v-btn
              >
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination.page"
          :length="pages"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>

      <v-dialog v-model="detail_dialog" width="800" dark style="padding:10px">
        <v-card>
          <v-card-title class="headline orange lighten-2" primary-title>
            تفاصيل الفاتورة
          </v-card-title>

          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm6 md4>
                الكود :
                {{ item_detail.code }}
              </v-flex>
              <v-flex xs12 sm6 md4>
                العميل :
                {{ item_detail.client ? item_detail.client.name : "" }}
              </v-flex>
              <v-flex xs12 sm6 md4>
                مندوب التوزيع :
                {{
                  item_detail.client && item_detail.client.mandob_sales
                    ? item_detail.client.mandob_sales.name
                    : ""
                }}
              </v-flex>
              <v-flex xs12 sm6 md4>
                المخزن :
                {{ item_detail.store ? item_detail.store.name : "" }}
              </v-flex>

              <v-flex xs12 sm6 md4>
                الخصم :
                {{ item_detail.discount }}
              </v-flex>
              <v-flex xs12 sm6 md4>
                السعر قبل :
                {{ item_detail.price_before }}
              </v-flex>
              <v-flex xs12 sm6 md4>
                السعر بعدها :
                {{ item_detail.price_before }}
              </v-flex>
              <v-flex xs12 sm6 md4>
                المتبقي :
                {{ item_detail.remain }}
              </v-flex>
              <v-flex xs12 sm6 md4>
                نوع السداد :
                {{ item_detail.sdad_type_name }}
              </v-flex>
              <v-flex xs12 sm6 md4>
                حالة السداد :
                {{ item_detail.sdad_status }}
              </v-flex>
            </v-layout>
            <hr />
            <v-data-table
              :headers="headers3"
              :items="item_detail.fatwora_items"
              class="elevation-1"
              :rows-per-page-items="rowsPerPageItems"
            >
              <template slot="items" slot-scope="props">
                <td>{{ props.item.item_name }}</td>
                <td>{{ props.item.item_num }}</td>
                <td>{{ props.item.item_bonus }}</td>
                <td>{{ props.item.item_num_after }}</td>
                <td>{{ props.item.total_price }}</td>
                <td>{{ props.item.item_discount }}</td>
                <td>{{ props.item.final_price }}</td>
              </template>
            </v-data-table>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="detail_dialog = false">
              موافق
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import {
  accept_fatwora,
  FinalFatworas,
  solmt_confirm,
  solmt_reject,
  add_fatwora,
  madionia_client,
  search_client_by_code
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    add_dialog: false,
    edit_dialog: false,
    dialog: false,

    date: new Date().toISOString().substr(0, 10),
    menu: false,
    modal: false,
    menu2: false,
    item_detail: "",
    detail_dialog: false,

    select_sadad_type: { id: "", job_name: "", name: "أختر نوع السداد" },
    select_client: { id: "", job_name: "", name: "أختر المورد" },
    select_employer: { id: "", job_name: "", name: "أختر المسئول" },
    select_store: { id: "", job_name: "", name: "أختر المخزن" },
    select_item: { id: "", job_name: "", name: "أختر الصنف" },
    select_sadadstatuses: { name: "" },

    search: "",
    loading: true,
    pagination: {
      rowsPerPage: 30,
      descending: true
    },
    headers: [
      {
        text: "الكود ",
        align: "right",
        value: "code"
      },
      { text: "العميل", value: "client.name", align: "right" },
      { text: "المندوب", value: "client.mandob_sales.name", align: "right" },
      { text: "المخزن", value: "store.name", align: "right" },
      { text: "السعر الكلي", value: "store", sortable: false, align: "right" },
      {
        text: " التاريخ",
        value: "created_at",
        sortable: false,
        align: "right"
      },
      {
        text: " تاريخ التسليم",
        value: "taslim_date",
        sortable: false,
        align: "right"
      },
      { text: "  التفاصيل", value: "store", sortable: false, align: "right" },
      {
        text: "  تعيين وطباعة",
        value: "store",
        sortable: false,
        align: "right"
      },
      { text: "قبول ", value: "store", sortable: false, align: "right" }
    ],
    headers3: [
      {
        text: "الصنف ",
        align: "right",
        value: "item"
      },
      { text: " العدد", value: "client_name", sortable: false, align: "right" },
      {
        text: " البونص",
        value: "client_name",
        sortable: false,
        align: "right"
      },
      {
        text: " العدد بعد",
        value: "client_name",
        sortable: false,
        align: "right"
      },
      { text: " السعر", value: "client_name", sortable: false, align: "right" },
      { text: " الخصم", value: "client_name", sortable: false, align: "right" },
      {
        text: " السعر بعد",
        value: "client_name",
        sortable: false,
        align: "right"
      }
    ],

    fatworas: [],
    m_sadad_types: [],
    m_employers: [],
    clients: [],
    m_items: [],
    stores: [],
    client_search_name: "",
    sadadstatuses: [],
    newItem: {
      id: "",
      code: "",
      madionia_sabqa: "",
      madionia_now: "",
      discount: "",
      price_before: "",
      price_after: "",
      sdad_type_name: "",
      sdad_status: "",
      emp_bill_amr: "",
      emp_create_fatwora: "",
      emp_sales_response_name: "",
      client_name: "",
      taslim_date: "",
      store_id: "",
      sadad_type_id: "",
      client_id: "",
      emp_sales_response_id: ""
    },
    madionia: {
      madionia_before: "",
      cost_or_money: "",
      madionia_after: "",
      emp_name: "",
      type_of_operation: "",
      code_of_operation: "",
      client_id: "",
      emp_id: ""
    },
    added_items: [],
    madionia_sabqa_of_madionia: ""
  }),

  computed: {
    mycode() {
      if (this.fatworas.length > 0) {
        return (this.code =
          parseInt(this.fatworas[this.fatworas.length - 1].code) + 1);
      } else {
        return (this.code = 1000);
      }
    },
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
    gettotalpriceitem: function() {
      return function(q, p) {
        return parseInt(q) * parseFloat(p);
      };
    },
    get_item_num_after: function() {
      return function(n, b) {
        if (b != 0) {
          return parseInt(n) + parseFloat(b);
        }
        return parseInt(n);
      };
    },
    get_item_final_price: function() {
      return function(p, d) {
        if (d != "") {
          return parseFloat(p) - parseFloat(d);
        }
        return parseFloat(p);
      };
    },

    fatwora_price() {
      let tot_price = 0;
      for (let index = 0; index < this.added_items.length; index++) {
        tot_price += parseFloat(this.added_items[index].total_price);
      }
      return (this.newItem.price_before = tot_price);
    },
    fatwora_final_price() {
      if (this.newItem.price_before != "" && this.newItem.discount != "") {
        return (this.newItem.price_after =
          parseFloat(this.newItem.price_before) -
          parseFloat(this.newItem.discount));
      }
      return (this.newItem.price_after = this.newItem.price_before);
    },
    madionia_now() {
      if (this.newItem.price_after > 0) {
        return (this.newItem.madionia_now =
          parseFloat(this.newItem.madionia_sabqa) +
          parseFloat(this.newItem.price_after));
      }
      return (this.newItem.madionia_now = this.newItem.madionia_sabqa);
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    // this.initialize()
    //  sadadtypes().then((response)=>{
    //          this.m_sadad_types=response.data
    //               });

    //       employers().then((response)=>{
    //         this.m_employers=response.data
    //       })

    //       items().then((response)=>{
    //         this.m_items=response.data
    //       })

    //       clients().then((response)=>{
    //         this.clients=response.data
    //       })

    FinalFatworas().then(response => {
      this.fatworas = response.data;
      this.pagination.totalItems = response.data.length;
      this.loading = false;
    });

    // stores().then((response)=>{
    //   this.stores=response.data

    // })

    // sadadstatuses().then((response)=>{
    //   this.sadadstatuses=response.data

    // })
  },

  methods: {
    initialize() {},

    add_item() {
      this.added_items.push({
        item_name: this.select_item.name,
        item_num_before: "",
        item_num: 1,
        item_num_after: "",
        item_discount: "",
        item_bonus: "",
        price: this.select_item.price_sell,
        total_price: this.select_item.total_price,
        final_price: this.select_item.final_price,
        item_id: this.select_item.id
      });
      this.select_item = { id: "" };
    },
    remove_item(item) {
      const index = this.added_items.indexOf(item);
      this.added_items.splice(index, 1);
    },
    change_client_name() {
      this.newItem.client_name = this.select_client.name;
      madionia_client(this.select_client.id).then(response => {
        this.newItem.madionia_sabqa = response.data.madionia;
        this.madionia_sabqa_of_madionia = response.data.madionia;
      });
    },
    change_employer_name() {
      this.newItem.emp_sales_response_name = this.select_employer.name;
    },
    change_sadad_name() {
      this.newItem.sdad_type_name = this.select_sadad_type.name;
    },
 

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
    },

    save(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          let myUser = JSON.parse(localStorage.getItem("user"));
          this.newItem.code = this.code;
          this.newItem.sadad_type_id = this.select_sadad_type.id;
          this.newItem.client_id = this.select_client.id;
          this.newItem.emp_sales_response_id = myUser.id;
          this.newItem.store_id = this.select_store.id;
          this.newItem.sdad_status = this.select_sadadstatuses.name;
          this.newItem.taslim_date = this.date;
          this.newItem.status = "1";
          this.newItem.emp_fatwora_taslim = myUser.name;

          this.madionia.madionia_before = this.madionia_sabqa_of_madionia;
          this.madionia.cost_or_money = this.newItem.price_after;
          this.madionia.madionia_after =
            parseFloat(this.madionia_sabqa_of_madionia) +
            parseFloat(this.newItem.price_after);
          this.madionia.emp_name = myUser.name;
          this.madionia.type_of_operation = "fatwora";
          this.madionia.code_of_operation = this.newItem.code;
          this.madionia.client_id = this.select_client.id;
          this.madionia.emp_id = myUser.id;

          var frmData = new FormData();
          frmData.append("fatwora", JSON.stringify(this.newItem));
          frmData.append("fatwora_items", JSON.stringify(this.added_items));
          frmData.append("madionia", JSON.stringify(this.madionia));

          add_fatwora(frmData).then(response => {
            Object.assign(this.$data.newItem, this.$options.data().newItem);
            // Object.assign(this.$data.select_sadad_type, this.$options.data().select_sadad_type);
            // Object.assign(this.$data.select_client, this.$options.data().select_client);
            // Object.assign(this.$data.select_employer, this.$options.data().select_employer);
            // Object.assign(this.$data.added_items, this.$options.data().added_items);
            // Object.assign(this.$data.select_item, this.$options.data().select_item);
            this.fatworas.push(response.data);
            this.loading = false;
            this.close();
            setTimeout(() => {
              this.$refs.form.reset();
            }, 1000);
          });
        }
      });
    },

    search_client_by_code() {
      search_client_by_code(this.client_search_name).then(response => {
        this.select_client = response.data;
        this.change_client_name();
      });
    },

    solmt_confirm(item) {
      var frmData = new FormData();
      let myUser = JSON.parse(localStorage.getItem("user"));
      frmData.append("emp_fatwora_solmt", myUser.name);
      solmt_confirm(item.id, frmData).then(response => {
        const index = this.fatworas.indexOf(item);
        this.fatworas.splice(index, 1);
      });
    },
    solmt_reject(item) {
      var frmData = new FormData();
      frmData.append("reason", item.reason);
      solmt_reject(item.id, frmData).then(response => {
        const index = this.fatworas.indexOf(item);
        this.fatworas.splice(index, 1);
      });
    },
    detailItem2(order) {
      this.item_detail = order;
    },
    accept_fatwora(id) {
      this.$swal({
        title: "هل تريد الأستمرار",
        text: "سيتم قبول الفاتورة بدلا من رفضها انت متاكد؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          this.loading = true;

          accept_fatwora(id).then(response => {
            FinalFatworas().then(response => {
              this.fatworas = response.data;
              this.pagination.totalItems = response.data.length;
              this.loading = false;
            });
          });
        }
      });
    }
  }
};
</script>

<style scope>
.v-datatable__actions {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
.flex,
.v-input.v-text-field,
.v-input__control {
  padding: 0px !important;
  margin: 0px !important;
}
.v-card__title,
.v-card__text {
  padding: 0px;
  margin: 0px;
}
</style>
